// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__BWNvr","label":"LabeledBox_label__2Bpiy"};